import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
// Copyright   : 2020 semantics GmbH
// Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
// Author      : Dirk Rothe
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 156393 $
// Purpose     : stats panels
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Table } from 'semantic-ui-react';
// ---Framework imports
import { get, isArray } from 'ldash';
import { Sel } from 'uix/registries';
import log from 'uix/logging';
import { usePhysicalNode, useSelector, useSummaries } from 'uix/hooks';
import { DashSegment } from 'uix/components/grid';
import { Link } from 'uix/components';
import { formatNumber } from 'uix/utils';
import { DatatypeDescription } from 'uix/types/components';
// ---Local imports
import { Plot } from './plots';
// ---Exports
const GrowthPlotPanel = ({ plotName, height = 260 })=>{
    if (isArray(plotName)) {
        return plotName.map((n)=>/*#__PURE__*/ _jsx(Plot, {
                showLegend: true,
                showMenu: "basic",
                name: n,
                height: height
            }, n));
    }
    return /*#__PURE__*/ _jsx(Plot, {
        showLegend: true,
        showMenu: "basic",
        name: plotName,
        height: height
    });
};
export const PlotPanel = {
    Comp: GrowthPlotPanel,
    datatypes: [
        'domain'
    ]
};
const NodeOverviewPlot = ({ height = 260 })=>{
    let node = usePhysicalNode();
    let plotName = 'countMetadata' // if domain
    ;
    return /*#__PURE__*/ _jsx(Plot, {
        showLegend: true,
        showMenu: "basic",
        name: plotName,
        height: height
    });
};
export const NodeOverviewPanel = {
    Comp: NodeOverviewPlot,
    align: 'right',
    datatypes: [
        'domain'
    ]
};
export const NodeStats = {
    Comp: ({ i18n })=>{
        let itypes = useSelector(Sel.itypes);
        let { dname } = useSelector(Sel.request);
        let { summaries: stats } = useSummaries([
            'datatype'
        ], dname);
        let get_stat = (dt, what)=>get(stats, `datatype.${dt}.${what}`, 0);
        let dts = [
            2,
            1,
            0,
            3,
            13,
            16,
            19
        ];
        let rows = dts.filter((dt)=>get_stat(dt, 'total')).map((dt)=>{
            return /*#__PURE__*/ _jsxs(Table.Row, {
                children: [
                    /*#__PURE__*/ _jsx(Table.Cell, {
                        children: /*#__PURE__*/ _jsx(DatatypeDescription, {
                            datatype: dt
                        })
                    }),
                    /*#__PURE__*/ _jsx(Table.Cell, {
                        children: /*#__PURE__*/ _jsx(Link, {
                            classname: "tree",
                            tabname: "list",
                            query: {
                                subdomains: true,
                                types: itypes.datatypeMap[dt]
                            },
                            children: formatNumber(get_stat(dt, 'total'))
                        })
                    })
                ]
            }, dt);
        });
        if (rows.length == 0) {
            return null;
        }
        return /*#__PURE__*/ _jsx(DashSegment, {
            header: i18n.get('inventory'),
            children: /*#__PURE__*/ _jsx(Table, {
                definition: true,
                compact: true,
                children: /*#__PURE__*/ _jsx(Table.Body, {
                    children: rows
                })
            })
        });
    },
    align: 'right',
    acl: 'g:admin',
    datatypes: [
        'domain'
    ]
};
